<template>
  <div class="widget-card widget-purse">
    <v-card class="widget-card__card" height="100%">
      <v-card-title class="primary white--text widget-card__card-title">
        Кошелёк
      </v-card-title>
      <v-card-text class="widget-card__card-text pt-3">
        Баланс: <b>{{user.balance}}</b>
      </v-card-text>
      <v-card-actions class="pa-3 widget-card__card-actions widget-purse__actions" bottom>
        <v-btn block color="default" to="/prizes" v-if="user.role_settings.property_can_spend_bonuses" class="mb-3 widget-card__actions-btn">
          <v-icon>mdi-location-exit</v-icon>
          <span class="pl-4">Вывести баллы</span>
        </v-btn>
        <v-btn block color="default" to="/purse" class="ml-0 widget-card__actions-btn">
          <v-icon>mdi-checkbox-multiple-blank-circle-outline</v-icon>
          <span class="pl-4">Движения баллов</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  export default {
    props: ['user'],
    computed: {
      isRus() {
        return this.$store.getters.isRus;
      },
      isBy() {
        return this.$store.getters.isBy;
      },
      isKz() {
        return this.$store.getters.isKz;
      },
    },
  };
</script>

<style lang="scss">
  .widget-purse {
    &__actions {
      flex-direction: column;
    }
  }
</style>
